import React from "react";

import { Main, Page } from '../../../components/Sidebar';


export default function UpcomingContractorsPaymentPage({ sidebar }: any) {
    return (
        <Page>
            <Main close={sidebar} style={{marginRight:"25vw"}}>
                <div className="m-4">
                    <p className="text-left font-bold text-2xl">UPCOMING CONTRACTOR PAYMENTS</p>
                </div>
            </Main>
            
        </Page>
    );
}
